import { useRouter } from 'vue-router'
import useLink from '@shared/composables/link.js'
import { getCurrentInstance } from 'vue'

export default function useRouteUtils() {

  let _router = getCurrentInstance() ? useRouter() : null
  async function getRouter() {
    if (!_router) {
      const { default: r } = await import('@/router.js')
      _router = r
    }
    return _router
  }

  /**
   * Navigate to the next route specified in the query params.
   * @param {RouteLocationRaw} fallback 
   */
  async function navigateToNext(fallback = { path: '/home' }) {
    const router = await getRouter()
    const query = router.currentRoute.value.query
    if ('next' in query) {
      const next = query.next
      const { isRouterLink, isHyperlink } = useLink(next)
      if (isRouterLink.value) {
        await router.push(next)
        return
      } else if (isHyperlink.value) {
        window.location.href = next
        return
      }
    }
    await router.push(fallback)
  }

  return {
    navigateToNext
  }
}